{
  "it": {
    "modelPicker": {
      "hangarTitle": "Aggiungi navi al tuo hangar",
      "compareTitle": "Seleziona navi da confrontare",
      "cargoGridsTitle": "Seleziona navi per la griglia di carico",
      "tradeRoutesTitle": "Scegli una nave per le rotte commerciali",
      "wishlistTitle": "Aggiungi navi alla tua lista dei desideri",
      "labels": {
        "search": "Cerca per nome o produttore",
        "hangarOnly": "Solo le mie navi",
        "containerFit": "Carico da trasportare",
        "results": "%{count} navi",
        "selected": "%{count} selezionate"
      },
      "actions": {
        "resetFilters": "Reimposta i filtri",
        "clearSelection": "Cancella la selezione",
        "increase": "Aggiungi un'altra %{name}",
        "decrease": "Rimuovi una %{name}"
      },
      "badges": {
        "inHangar": "Nell'hangar",
        "onWishlist": "Nella lista dei desideri",
        "comparing": "Nel confronto",
        "onCargoGrid": "Nella griglia"
      }
    }
  }
}
